export default __webpack_public_path__ + "images/gotomypc-8a04ead7ec5406997729f43d2b92978a.svg";